import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import clsx from 'clsx'

const TextSection = ({ heading, _rawRichtext, pattern, blockId }) => (
	<section id={blockId} className={clsx(pattern)}>
		<div className="section text-center richtext">
			<HTag className="h1" {...heading} />
			<Richtext className="h1 leading-snug" raw={_rawRichtext} />
		</div>
	</section>
)

export default TextSection
